// ==============================================
// ==================Import======================
// ==============================================

// ==================Dependance===================
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';
// ==================Style&IMG===================
import './style.scss';

// ==================Actions===================
import { setOpenCookiePopup } from '../../actions/popupCookie';

function PopupCookie() {
  // ==================HOOK===================
  const dispatch = useDispatch();
  const openCookiePopup = useSelector((state) => state.popupCookie.openCookiePopup);

  // ================classnames=====================

  const displayCookiePopup = classNames('popupCookie--container', { 'popupCookie--container__close': !openCookiePopup });

  // stock value selected by user for popup in localstorage
  function handleDisplayModal(evt) {
    localStorage.setItem('cookiePopup', JSON.stringify({
      value: evt.target.checked,
      expire_date: (Date.now()) + (2629800000),
    }));
  }

  return (
    <div className={displayCookiePopup}>
      <div className="popupCookie--container__height">
        <h2 className="popupCookie--container__title">Cookies Policy</h2>
        <p className="popupCookie--container__text">
          By using our website you are consenting to our use of cookies
          in accordance with GDPR compliance
          <a
            href="https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32016R0679"
            target="_blank"
            rel="noreferrer"
          > cookies policy
          </a>
          .
        </p>
        <div className="popupCookie--container__button">
          <label htmlFor="cookie--checkbox">
            <input id="cookie--checkbox" name="cookie--checkbox" type="checkbox" onClick={(evt) => handleDisplayModal(evt)} /> Don't show again
          </label>
          <button className="popupCookie--container__button__close" type="button" onClick={() => dispatch(setOpenCookiePopup(false))}>Close</button>
        </div>
      </div>
    </div>
  );
}

export default PopupCookie;
